<script lang="ts">
  export let stepTitle: string;
  export let stepDescription: string;
</script>

<div class="flex flex-col gap-2">
  <h2 class="text-xl text-gray-900 font-semibold lg:text-display-xxs">{stepTitle}</h2>
  <p class="text-lg text-gray-600 font-normal">{stepDescription}</p>
</div>
